<template>
  <v-text-field
    v-bind="$attrs"
    v-model="valeur"
    @input="changed"
    type="number"
    :disabled="disabled"
    :data-testid="dataTestid"
  >
    <template v-slot:append>
      <a-duree-select
        style="width: 80px"
        dense
        hide-details
        v-model="unite"
        @change="changed"
        :disabled="disabled"
    :data-testid="dataTestid"
      />
    </template>
  </v-text-field>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";

function mapTo(src, dest) {
  dest.valeur = src.valeur;
  dest.unite = src.unite;
}

export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [makeValueData(mapTo)],
};
</script>


